import { passSugnCrossIcon, passSugnTickIcon } from "../assets/superAdminAssets";
import { Constants } from "../constants";

export function convertToFormData(data, formData = new FormData(), parentKey = '') {
    if (data === null || data === undefined) return formData;

    if (data instanceof File || data instanceof Blob) {
        formData.append(parentKey, data);
        return formData;
    }

    if (Array.isArray(data)) {
        data.forEach((value, index) => {
            const key = parentKey ? `${parentKey}[${index}]` : index;
            convertToFormData(value, formData, key);
        });
        return formData;
    }

    if (typeof data === 'object') {
        Object.keys(data).forEach(key => {
            const fullKey = parentKey ? `${parentKey}.${key}` : key;
            convertToFormData(data[key], formData, fullKey);
        });
        return formData;
    }

    formData.append(parentKey, data);
    return formData;
}

// Function to decrypt text
export const decryptText = (encryptedText) => {
    let key = Constants.CRYPTO_SECRET_KEY;
    // Convert Base64 to encrypted text
    const encrypted = decodeURIComponent(escape(atob(encryptedText))); // Decode Base64 to original encrypted text
    let result = '';
    for (let i = 0; i < encrypted.length; i++) {
        const charCode = encrypted.charCodeAt(i) ^ key.charCodeAt(i % key.length);
        result += String.fromCharCode(charCode);
    }
    return result;
};

export const renderPasswordHelperText = (passwordValidations) => (
    <div className="password-suggestion-box">
        <div className="d-flex">
            <img src={passwordValidations.length ? passSugnTickIcon : passSugnCrossIcon} alt="" />
            {passwordValidations.length ? "8 characters minimum." : "At least 8 characters."}
        </div>
        <div className="d-flex">
            <img src={passwordValidations.uppercase ? passSugnTickIcon : passSugnCrossIcon} alt="" />
            {passwordValidations.uppercase ? "One uppercase letter." : "One uppercase letter is missing."}
        </div>
        <div className="d-flex">
            <img src={passwordValidations.lowercase ? passSugnTickIcon : passSugnCrossIcon} alt="" />
            {passwordValidations.lowercase ? "One lowercase letter." : "One lowercase letter is missing."}
        </div>
        <div className="d-flex">
            <img src={passwordValidations.numeric ? passSugnTickIcon : passSugnCrossIcon} alt="" />
            {passwordValidations.numeric ? "One numeric digit." : "One numeric digit is missing."}
        </div>
        <div className="d-flex">
            <img src={passwordValidations.special ? passSugnTickIcon : passSugnCrossIcon} alt="" />
            {passwordValidations.special ? "One special character (!, #, %)." : "One special character is missing."}
        </div>
        {/* <div className="d-flex">
        <img src={pass_sugn_cross} alt="" />
        Personal Information not allowed.
      </div> */}
    </div>
);

/**
 * Recursively converts the first letter of each object key to uppercase.
 * Handles nested objects and arrays and returns a new structure.
 *
 * Example:
 * { foo: 1, barBaz: { qux: 2 } } -> { Foo: 1, BarBaz: { Qux: 2 } }
 */
export const capitalizeKeysDeep = (data) => {
    if (data === null || data === undefined) return data;
    if (Array.isArray(data)) {
        return data.map((item) => capitalizeKeysDeep(item));
    }
    if (typeof data === 'object' && !(data instanceof Date) && !(data instanceof File) && !(data instanceof Blob)) {
        const result = {};
        Object.keys(data).forEach((key) => {
            const newKey = key ? key.charAt(0).toUpperCase() + key.slice(1) : key;
            result[newKey] = capitalizeKeysDeep(data[key]);
        });
        return result;
    }
    return data;
};

export const getBoolean = (value) => {
    const yes = value?.toString()?.toLowerCase() == 'true' || value == 1 || value?.toString()?.toLowerCase() == 'yes';
    const no = value?.toString()?.toLowerCase() == 'false' || value == 0 || value?.toString()?.toLowerCase() == 'no';

    return yes ? true : false;
}

export const getMonthNumber = (month) => {
    const monthNumber = {
        'jan': 1,
        'feb': 2,
        'mar': 3,
        'apr': 4,
        'may': 5,
        'jun': 6,
        'jul': 7,
        'aug': 8,
        'sep': 9,
        'oct': 10,
        'nov': 11,
        'dec': 12,
    }
    return monthNumber[month.toLowerCase()] || 0;
}

export const base64ToFile = (dataUrl, fileName, mimeType) => {
    if (!dataUrl) return '';
    const [meta, base64] = dataUrl.split(",");
    const mime = meta.match(/:(.*?);/)?.[1] || mimeType;

    const binary = atob(base64);
    const array = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
        array[i] = binary.charCodeAt(i);
    }

    return new File([array], fileName, { type: mime });
};


export function sortSelectList(list) {
    return list.sort((a, b) => {
        const isEmptyOrZero = val => val === "" || val === "-" || val === "0" || val === 0;

        // when using custom objects they may not have a .value property, so
        // support fallback to UserId (common in our APIs) or simply treat
        // undefined as non-empty/zero.
        const aVal = isEmptyOrZero(a?.value) || isEmptyOrZero(a?.UserId);
        const bVal = isEmptyOrZero(b?.value) || isEmptyOrZero(b?.UserId);

        if (aVal && !bVal) return -1;
        if (!aVal && bVal) return 1;

        // choose label or fallback to FullName for display
        const aLabel = typeof a?.label === "string" ? a.label :
            typeof a?.FullName === "string" ? a.FullName : "";
        const bLabel = typeof b?.label === "string" ? b.label :
            typeof b?.FullName === "string" ? b.FullName : "";

        return aLabel.localeCompare(bLabel);
    });
}